import { Col, Image, Row } from "react-bootstrap"
import { useSelector } from "react-redux"
import { regionCode } from "../../States";


const AddressSection = () => {
    const businessDetails = useSelector((state) => state?.getSetting?.dataSetting);
    const findState = regionCode.length > 0 && regionCode.find((value) => value.id == businessDetails?.state);
    console.log("businessDetails",businessDetails)
    return (
        <>
            <Row className="">
                <Col lg={12} className="d-flex justify-content-center align-items-center">
                    <Image src={businessDetails?.logo} height={60} style={{ width: 'auto', objectFit: 'contain' }} />
                </Col>

            </Row>
            <Row className="" >
                <Col lg={12} >
                    <div className="d-flex flex-column align-items-center">
                        <text className="bold fs-3" >{businessDetails?.business_name}</text>
                        <text>{businessDetails?.business_address},</text>
                        <text>{businessDetails?.city}, {findState?.name} - {businessDetails?.pincode}.</text>
                        {businessDetails?.business_phone && (
                            <text className="bold">
                                Mobile : <span style={{ fontWeight: 400 }}>{businessDetails?.business_phone}</span>
                            </text>
                        )}
                        {businessDetails?.gstin && (
                            <text className="bold">
                                GSTIN : <span>{businessDetails.gstin}</span>
                            </text>
                        )}
                    </div>
                </Col>
            </Row>
            <hr />
        </>
    )
}

export default AddressSection;